import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolItem } from '../../classes/tool-item';
import { ITool } from '../../interfaces/tool.interface';
import { ToolsService } from '../../services/tools.service';
import {
  VerbalAudioType,
  VerbalService,
} from 'src/app/modules/read-aloud/services';
import { ToolID } from '../../enums/tool-id';
import { PopulationService } from 'src/app/shared/services/population/population.service';

@Component({
  selector: 'htc-tools',
  template: ` <ng-template #tools htcViewContainerDirective></ng-template> `,
  standalone: false,
})
export class ToolComponent implements OnInit, OnDestroy {
  @ViewChild('tools', { static: true, read: ViewContainerRef })
  toolsViewContainer!: ViewContainerRef;
  toolItems: ToolItem[] = [];
  sub = new Subscription();

  constructor(
    private toolsService: ToolsService,
    private verbalService: VerbalService,
    private populationService: PopulationService
  ) {}

  ngOnInit(): void {
    this.toolItems = this.toolsService.getTools();

    this.sub.add(
      this.toolsService.getActivatedTools().subscribe(toolIds => {
        if (this.toolsViewContainer) {
          this.toolsViewContainer.clear();
          this.loadComponents(toolIds);
        }
      })
    );
  }

  loadComponents(toolIds: number[]): void {
    for (let toolId = 0; toolId < toolIds.length; toolId++) {
      const viewRef = this.toolsViewContainer.get(toolId);
      const matchedTool = this.toolItems.find(
        tool => tool.data.id === toolIds[toolId]
      );
      const overrideOnClickType = matchedTool?.data.overrideOnClickType;
      if (overrideOnClickType) {
        switch (overrideOnClickType) {
          case 'VERBAL_PROMPT':
            this.verbalService.playPopulationAudio(VerbalAudioType.PROMPT);
            this.toolsService.deactivateTool(matchedTool.data.id);
            break;
          // add additional override cases here if needed
        }
        return;
      }
      // To skip default behavior for Hint button for verbal population
      // TODO: AMR - POST BTS: This should be handled with the overrideOnClickType once tools are changed to BehaviourSubjects.
      if (
        matchedTool?.data.id === ToolID.ON_DEMAND_HINT &&
        this.populationService.currentPopulation.value?.verbal
      ) {
        this.verbalService.playPopulationAudio(VerbalAudioType.HINT);
        this.toolsService.deactivateTool(matchedTool.data.id);
        return;
      }
      if (viewRef === null && matchedTool !== undefined) {
        const componentRef = this.toolsViewContainer.createComponent<ITool>(
          matchedTool.component
        );
        componentRef.instance.id = matchedTool.data.id;
        componentRef.instance.icon = matchedTool.data.icon;
        componentRef.instance.toggledIcon = matchedTool.data.toggledIcon;
      }
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
